var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.todosDias)?_c('span',[_vm._v("Todos os dias da semana")]):(_vm.nenhumDia)?_c('span',[_vm._v("Nenhum dia da semana")]):_c('span',[_vm._v(_vm._s(_vm.diasDaSemanaSelecionados))])])
}
var staticRenderFns = []

export { render, staticRenderFns }